// @flow

type SecretAction = { type: string };

export default {
  prefillTopics: (): SecretAction => ({ type: 'SECRET_PREFILL_TOPICS' }),
  prefillCurrentMethods: (): SecretAction => ({ type: 'SECRET_PREFILL_CURRENT_METHODS' }),
  prefillActiveRecs: (): SecretAction => ({ type: 'SECRET_PREFILL_ACTIVE_RECS' }),
};
